import "./Header.scss";

import React from "react";
import { Link, Route } from "react-router5";

import {
  ROUTE_LOGIN,
  ROUTE_MAP,
  ROUTE_STATS,
  ROUTE_TABLE,
  ROUTE_TABLESUM,
  ROUTE_DATABASE,
  ROUTE_EVENTLOG,
  ROUTE_SEALNUMS,
  ROUTE_WORKSHIFT,
  ROUTE_PROCESSED_QUALITIES,
  ROUTE_RAW_QUALITIES,
  ROUTE_MIXES,
  ROUTE_STAT_ACTIVITY,
  ROUTE_PALLET_CHECK,
  ROUTE_TRANSPORTER_MOVE,
  ROUTE_TRANSPORTER_CHECK,
} from "../../routes";
import { STORE_AUTH } from "../../Store/AuthStore";
import { observer, inject } from "mobx-react";
import { useCookies } from "react-cookie";

function HeaderComponent(props) {
  const [cookies, setCookie] = useCookies(["logicort-user"]);
  const { authStore, router } = props;
  const permissionlevel = authStore.user
    ? authStore.user.PermissionLevel
    : null;
  return (
    <div className="header">
      <div className="header__brand">
        <img
          className="header__brand-image"
          src="/img/logo.png"
          alt="Logicort"
        />
      </div>
      {authStore.user ? (
        [
          <nav key="menu" className="header__menu">
            {(permissionlevel === 1 || permissionlevel === 12) && (
              <Link
                className="header__menu-item"
                activeClassName="header__menu-item--active"
                routeName={ROUTE_MAP}
              >
                Térkép
              </Link>
            )}
            {(permissionlevel === 1 || permissionlevel === 12) && (
              <Link
                className="header__menu-item"
                activeClassName="header__menu-item--active"
                routeName={ROUTE_TABLE}
              >
                Táblázat
              </Link>
            )}
            {(permissionlevel === 1 || permissionlevel === 12) && (
              <Link
                className="header__menu-item"
                activeClassName="header__menu-item--active"
                routeName={ROUTE_TABLESUM}
              >
                Készlet
              </Link>
            )}
            {(permissionlevel === 1 || permissionlevel === 12) && (
              <Link
                className="header__menu-item"
                activeClassName="header__menu-item--active"
                routeName={ROUTE_STATS}
              >
                Statisztika
              </Link>
            )}
            {(permissionlevel === 1 || permissionlevel === 12) && (
              <Link
                className="header__menu-item"
                activeClassName="header__menu-item--active"
                routeName={ROUTE_DATABASE}
              >
                Törzsadat
              </Link>
            )}
            {(permissionlevel === 1 || permissionlevel === 12) && (
              <Link
                className="header__menu-item"
                activeClassName="header__menu-item--active"
                routeName={ROUTE_EVENTLOG}
              >
                Esemény
              </Link>
            )}
            {permissionlevel === 1 && (
              <Link
                className="header__menu-item"
                activeClassName="header__menu-item--active"
                routeName={ROUTE_STAT_ACTIVITY}
              >
                Aktivitás
              </Link>
            )}
            {(permissionlevel === 1 || permissionlevel === 12) && (
              <Link
                className="header__menu-item"
                activeClassName="header__menu-item--active"
                routeName={ROUTE_WORKSHIFT}
              >
                Műszaknapló
              </Link>
            )}
            {(permissionlevel === 1 || permissionlevel === 12) && (
              <Link
                className="header__menu-item"
                activeClassName="header__menu-item--active"
                routeName={ROUTE_PALLET_CHECK}
              >
                Raklap ellenőrzés
              </Link>
            )}
            {(permissionlevel === 1 || permissionlevel === 12) && (
              <Link
                className="header__menu-item"
                activeClassName="header__menu-item--active"
                routeName={ROUTE_TRANSPORTER_MOVE}
              >
                Targonca napló
              </Link>
            )}
            {(permissionlevel === 1 || permissionlevel === 12) && (
              <Link
                className="header__menu-item"
                activeClassName="header__menu-item--active"
                routeName={ROUTE_TRANSPORTER_CHECK}
              >
                Targonca ellenőrzés
              </Link>
            )}
            {(permissionlevel === 1 || permissionlevel === 12) && (
              <Link
                className="header__menu-item"
                activeClassName="header__menu-item--active"
                routeName={ROUTE_SEALNUMS}
              >
                Fémzárszám
              </Link>
            )}
            {(permissionlevel === 1 ||
              permissionlevel === 10 ||
              permissionlevel === 11) && (
              <Link
                className="header__menu-item"
                activeClassName="header__menu-item--active"
                routeName={ROUTE_PROCESSED_QUALITIES}
              >
                Feldolgozott áru
              </Link>
            )}
            {(permissionlevel === 1 ||
              permissionlevel === 10 ||
              permissionlevel === 11) && (
              <Link
                className="header__menu-item"
                activeClassName="header__menu-item--active"
                routeName={ROUTE_RAW_QUALITIES}
              >
                Nyers áru
              </Link>
            )}
            {(permissionlevel === 1 || permissionlevel === 12) && (
              <Link
                className="header__menu-item"
                activeClassName="header__menu-item--active"
                routeName={ROUTE_MIXES}
              >
                Keverék
              </Link>
            )}
          </nav>,
          <nav key="menu-secondary" className="header__menu-secondary">
            <div className="header__menu__current-user">
              {authStore.user.Name}
            </div>
            <img
              className="header__menu-logout"
              src="/img/logout.png"
              onClick={(e) => {
                e.preventDefault();
                authStore.setUser(null);
                setCookie("logicort-user", null);
                router.navigate(ROUTE_LOGIN);
                return false;
              }}
            />
          </nav>,
        ]
      ) : (
        <nav className="header__menu header__menu--not-logged-in">
          <Link
            className="header__menu-item hidden"
            activeClassName="header__menu-item--active"
            routeName={ROUTE_LOGIN}
          >
            Belépés
          </Link>
        </nav>
      )}
    </div>
  );
}

const Header = inject((stores) => ({
  authStore: stores.store.get(STORE_AUTH),
}))(
  observer((props) => (
    <Route>
      {(routerProps) => <HeaderComponent {...routerProps} {...props} />}
    </Route>
  ))
);

export default Header;
